import React from 'react';
import { Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { compose, graphql } from 'react-apollo';
import { createBrowserHistory } from 'history';
import queryString from 'query-string';

import getLocale from './graphql/getlocale.gql';

function preserveQueryParameters(history, location) {
  const currentQuery = queryString.parse(history.location.search);
  if (currentQuery) {
    if (location.search) {
      Object.assign(currentQuery, queryString.parse(location.search));
    }
    // eslint-disable-next-line no-param-reassign
    location.search = queryString.stringify(currentQuery);
  }
  return location;
}

function clearQueryParameters(history) {
  const location = history.location;
  location.search = '';
  return location;
}

function createLocationDescriptorObject(location, state) {
  return typeof location === 'string'
    ? { pathname: location, state }
    : location;
}

function createPreserveQueryHistory(options) {
  const history = createBrowserHistory(options);
  const oldPush = history.push;
  const oldReplace = history.replace;
  history.push = (path, state) =>
    oldPush.apply(history, [
      preserveQueryParameters(
        history,
        createLocationDescriptorObject(path, state)
      ),
    ]);
  history.replace = (path, state) =>
    oldReplace.apply(history, [
      preserveQueryParameters(
        history,
        createLocationDescriptorObject(path, state)
      ),
    ]);
  history.clearSearch = () =>
    oldReplace.apply(history, [clearQueryParameters(history)]);
  return history;
}

export class LocalizedRouter extends React.PureComponent {
  history = createPreserveQueryHistory({
    basename: this.props.languageState.locale,
  });

  render() {
    const locale = this.props.languageState.locale;

    return (
      <IntlProvider
        locale={locale}
        // key={locale}
        messages={this.props.messages[locale]}
      >
        <Router history={this.history}>{this.props.children}</Router>
        {/* <BrowserRouter basename={locale}>
          {this.props.children}
        </BrowserRouter> */}
      </IntlProvider>
    );
  }
}

export default compose(
  graphql(getLocale, {
    props: ({ data: { languageState } }) => ({
      languageState,
    }),
  })
)(LocalizedRouter);



// WEBPACK FOOTER //
// ./app/components/LocalizedRouter/index.js